import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import ModalGeneric from "../../../Common/ModalGeneric";
import UpdateOpenModal from "../../CreateModals/UpdateOpenModal";
import InternkoderForm from "../../InternkoderForm";

import { putInternkoderIleggelser } from "../../../../actions/internkoderIleggelserActions";
import { putInternkoderMiljogebyr } from "../../../../actions/internkoderMiljogebyrActions";
import {
    IsValidated,
    onChangeValidation,
} from "../../../../utils/validationUtils";

const rules = {
  id: "required;isDigit",
  beskrivelse: "required;minLength=3;maxLength=50",
  aktivertDato: "isDato;isLessThan=deaktivertDato",
  deaktivertDato: "isDato;isLargerThan=aktivertDato",
};

function InternkoderModal({ id, beskrivelse, aktivertDato, deaktivertDato, modalToRender }) {
  const dispatch = useDispatch();

  const initState = () => ({
    open: false,
    submitButtonText: "Lagre",
    id,
    beskrivelse,
    aktivertDato,
    deaktivertDato,
    validationError: {},
    openDeaktiverConfirm: false,
  });

  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  useEffect(() => {
    setState((s) => ({ ...s, id, beskrivelse, aktivertDato, deaktivertDato }));
  }, [id, beskrivelse, aktivertDato, deaktivertDato]);

  const closeModal = () => setState(initState());
  const openModal = () => update({ open: true });

  const isValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePut = () => {
    update({ submitButtonText: "Lagrer..." });

    const payload = {
      beskrivelse: state.beskrivelse,
      aktivertDato: state.aktivertDato || null,
      deaktivertDato: state.deaktivertDato || null,
    };

    const action =
      modalToRender === "ileggelser"
        ? dispatch(putInternkoderIleggelser(state.id, payload))
        : dispatch(putInternkoderMiljogebyr(state.id, payload));

    action
      .then(() => closeModal())
      .catch(() => update({ submitButtonText: "Lagre" }));
  };

  const saveAndClose = () => {
    if (isValid() && !state.deaktivertDato) {
      handlePut();
    } else if (isValid() && state.deaktivertDato) {
      update({ open: false, openDeaktiverConfirm: true });
    }
  };

  const handleChange = (e) => {
    const draft = { ...state, [e.target.name]: e.target.value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  const modalTitle =
    modalToRender === "ileggelser"
      ? "Rediger internkode for ileggelser"
      : "Rediger internkode for miljøgebyr";

  return (
    <>
      <ModalGeneric
        modalTitle={modalTitle}
        open={state.open}
        closeModal={closeModal}
        openModal={openModal}
        OpenModalComponent={UpdateOpenModal}
        submit={saveAndClose}
        submitButtonText="Lagre"
      >
        <InternkoderForm
          id={state.id}
          beskrivelse={state.beskrivelse}
          aktivertDato={state.aktivertDato}
          deaktivertDato={state.deaktivertDato}
          handleChange={handleChange}
          validationError={state.validationError}
          actionType="update"
        />
      </ModalGeneric>
      <ModalGeneric
        modalTitle="Deaktiver internkode"
        open={state.openDeaktiverConfirm}
        closeModal={() => update({ openDeaktiverConfirm: false, open: true })}
        submit={handlePut}
        submitButtonText={state.submitButtonText}
      >
        <p>Vil du deaktivere internkode {state.id}?</p>
      </ModalGeneric>
    </>
  );
}

export default InternkoderModal;

